import { render, staticRenderFns } from "./TwoPhaseMethodSettingEdit.vue?vue&type=template&id=03abf48c&scoped=true"
import script from "./TwoPhaseMethodSettingEdit.vue?vue&type=script&lang=js"
export * from "./TwoPhaseMethodSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./TwoPhaseMethodSettingEdit.vue?vue&type=style&index=0&id=03abf48c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03abf48c",
  null
  
)

export default component.exports